import React from 'react';
import Carousel from 'nuka-carousel';

if (process.env.BROWSER) {
  require('../../list-view.scss');
  require('./event-slider-box.scss');
}

class EventPage extends React.Component {
  render() {
    return (

      <div className="list__view-wrapper selected-event-render">
        {/* Left list view Container */}
        <div className="list-view-left-area">

          <div className="events-slider">
            <Carousel
              slidesToShow={5}
              slidesToScroll={1}
              cellSpacing={0}
              initialSlideHeight={61}
              renderBottomCenterControls={() => ('')}
              renderCenterLeftControls={({ previousSlide }) => (<button onClick={previousSlide}></button>)}
              renderCenterRightControls={({ nextSlide }) => (<button onClick={nextSlide}></button>)}>
              <div className="slider-item selected-slider-item">
                <div className="slider-item-title">United Kingdom / Elections</div>
                <div className="slider-item-event-name">Next UK General Election</div>
                <div className="slider-item-event-date">1 Jan 2022 | 11:00</div>
              </div>
              <div className="slider-item">
                <div className="slider-item-title">United Kingdom / Elections</div>
                <div className="slider-item-event-name">Next UK General Election</div>
                <div className="slider-item-event-date">1 Jan 2022 | 11:00</div>
              </div>
              <div className="slider-item">
                <div className="slider-item-title">United Kingdom / Elections</div>
                <div className="slider-item-event-name">Next UK General Election</div>
                <div className="slider-item-event-date">1 Jan 2022 | 11:00</div>
              </div>
              <div className="slider-item">
                <div className="slider-item-title">United Kingdom / Elections</div>
                <div className="slider-item-event-name">Next UK General Election</div>
                <div className="slider-item-event-date">1 Jan 2022 | 11:00</div>
              </div>
              <div className="slider-item">
                <div className="slider-item-title">United Kingdom / Elections</div>
                <div className="slider-item-event-name">Next UK General Election</div>
                <div className="slider-item-event-date">1 Jan 2022 | 11:00</div>
              </div>
              <div className="slider-item">
                <div className="slider-item-title">United Kingdom / Elections</div>
                <div className="slider-item-event-name">Next UK General Election</div>
                <div className="slider-item-event-date">1 Jan 2022 | 11:00</div>
              </div>
              {/* {eventList.map((item, index) => {
            return (
              <EventSliderBox key={index} event={item}/>
            )
          })}*/}
            </Carousel>
          </div>
          {/* .events-slider END */}

          <div className="top-image__header header__politics">
            <div className="bannerShadow"></div>
            <div className="selected-event-header">
              <div className="selected-event-date">1 Jan 2022 11:00</div>
              <div className="selected-event-name">Next UK General Election</div>
            </div>

            {/* Left list view col 1 */}
            <div className="event-selection-data pull-left">
              <div className="data__header">
                <span className="v-line"></span>
                <h3><span className="event-icon event-icon--politics"></span>Most Popular</h3>
                <span className="data__header-arrow"><span className="nr-of-selections">2</span><span
                  className="arrow-up"></span></span>
              </div>
              <div className="data-expand-container">
                <div className="event-data-row">

                  <div className="main-data-event">
                    <div className="event-icon event-icon--politics"></div>
                    <div className="main-event-content">
                      <div className="main-name-and-details">
                        <div>
                          <div className="main-event-title">
                            Party to obtain most seats
                          </div>
                          <div className="main-event-details">5 Parties</div>
                        </div>
                      </div>
                      <div className="main-date-time-and-liveMarker">
                        <div className="live-marker-pc"></div>
                        <div className="main-date-time">
                          <div className="main-event-date">25 Dec 2018</div>
                          <div className="main-event-time">11:00</div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="button-wrapper">
                    <button className="main-btn dark-btn">
                      <div className="bet--title">Conservatives</div>
                      <div className="bet--value">2.00</div>
                    </button
                    >
                    <button className="main-btn dark-btn">
                      <div className="bet--title">Labour</div>
                      <div className="bet--value">1.74</div>
                    </button>
                    <button className="main-btn dark-btn link--dots-btn"><span></span><span></span><span></span>
                    </button>
                  </div>

                </div>
              </div>
            </div>
            {/* Left list view col 1 END */}

            {/* Left list view col 2 */}
            <div className="event-selection-data pull-right">
              <div className="data__header">
                <span className="v-line"></span>
                <h3><span className="event-icon event-icon--politics"></span>Elections</h3>
                <span className="data__header-arrow"><span className="nr-of-selections">3</span><span
                  className="arrow-up"></span></span>
              </div>
              <div className="data-expand-container">
                <div className="event-data-row">

                  <div className="main-data-event">
                    <div className="event-icon event-icon--politics"></div>
                    <div className="main-event-content">
                      <div className="main-name-and-details">
                        <div>
                          <div className="main-event-title">
                            Party to obtain most seats
                          </div>
                          <div className="main-event-details">5 Parties</div>
                        </div>
                      </div>
                      <div className="main-date-time-and-liveMarker">
                        <div className="live-marker-pc"></div>
                        <div className="main-date-time">
                          <div className="main-event-date">25 Dec 2018</div>
                          <div className="main-event-time">11:00</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="button-wrapper">
                    <button className="main-btn dark-btn">
                      <div className="bet--title">Conservatives</div>
                      <div className="bet--value">2.00</div>
                    </button>
                    <button className="main-btn dark-btn">
                      <div className="bet--title">Labour</div>
                      <div className="bet--value">1.74</div>
                    </button>
                    <button className="main-btn dark-btn">
                      <div className="bet--title">Democrats</div>
                      <div className="bet--value">3.74</div>
                    </button>
                    <button className="main-btn dark-btn">
                      <div className="bet--title">Anarchists</div>
                      <div className="bet--value">1.10</div>
                    </button>
                    <button className="main-btn dark-btn link--dots-btn"><span></span><span></span><span></span>
                    </button>
                  </div>
                </div>
              </div>
              {/* Left list view col 2 END */}
            </div>
          </div>
          {/* Left list view Container END */}

          {/* Right list view Container */}
          <div className="list-view-right-area">
            <div className="btc__content">
              <div>
                Event details
              </div>
              <div>
                Bet offers list
              </div>
            </div>
          </div>
          {/* Right list view Container END */}
        </div>
      </div>
    );
  }
}

export default EventPage;
